/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/unbound-method */
import { Component, type ElementRef, Inject, PLATFORM_ID, ViewChild, type OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CommonModule, CurrencyPipe, DecimalPipe, formatDate, isPlatformBrowser } from '@angular/common';
import { catchError, concatMap, EMPTY, map, type Observable, throwError } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router } from '@angular/router';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import {
  type MatDatepicker,
  type MatCalendarCellClassFunction,
  MatDatepickerModule,
} from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';

import { CreditCardFormComponent } from '../../shared/components/credit-card-form/credit-card-form.component';
import { BankAccountFormComponent } from '../../shared/components/bank-account-form/bank-account-form.component';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PaymentService } from '../../shared/services/payment.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';

import { StorageEnum } from '../../shared/enums/storage.enum';
import { PaymentAccountType } from '../../shared/enums/paymentaccounttype.enum';
import { PaymentMethod } from '../../shared/models/payment-method';
import { AccountDetail } from '../../shared/models/account-detail';
import { OtherAmountValidator } from '../other-amount-validator';

import { NgxMaskDirective } from 'ngx-mask';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PaymentDialogResult } from '../../shared/models/payment-dialog-result';
import {
  add,
  addDays,
  endOfMonth,
  format,
  isAfter,
  isEqual,
  isFuture,
  isWithinInterval,
  subDays,
  toDate,
} from 'date-fns';
import {
  BankPayment,
  CardPayment,
  FuturePaymentRequest,
  Payment,
  type PaymentResponse,
} from '../../shared/models/payment';
import { type UserProfile } from '../../shared/models/user-profile';
import { CreditPipe } from '../../shared/pipes/credit.pipe';
import { DialogResultType } from '../../shared/enums/dialogresulttype.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PaymentusService } from '../../shared/services/paymentus.service';
import { environment } from '../../../environments/environment';
import { ErrorData } from '../../shared/models/error-data';
import { DigitalPaymentModalComponent } from '../../shared/components/digital-payment-modal/digital-payment-modal.component';
import { Capacitor } from '@capacitor/core';
import { PaymentErrorCode } from '../../shared/enums/paymenterrorcode.enum';
import { CTA, SuccessData } from '../../shared/models/success-data.model';
import { type FuturePayment } from '../../shared/models/future-payment';
import { Nav } from '../../shared/enums/nav.enum';
import { EmailInfo } from '../../shared/models/email-info';
import { emailValidator } from '../../shared/validators/email.validator';
import { EmailFormComponent } from '../../shared/components/email-form/email-form.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../shared/services/account.service';
import { SONPCode } from '../../shared/enums/sonpcode.enum';
import { CreateToDo } from '../../shared/models/create-to-do';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CustomerService } from '../../shared/services/customer.service';
import { CreateCustomerContact } from '../../shared/models/create-customer-contact';
import { NotificationType } from '../../shared/enums/notificationtype.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
import { CustomerClassEnum } from '../../shared/enums/customerclass.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.scss',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatRadioModule,
    NgxMaskDirective,
    MatDatepickerModule,
    MatDividerModule,
    MatCardModule,
    MatCheckboxModule,
    MatTooltipModule,
    CreditPipe,
    EmailFormComponent,
    NotificationComponent,
    PageHeaderComponent,
  ],
  providers: [CreditPipe, CurrencyPipe, DecimalPipe],
})
export class PaymentComponent implements OnInit {
  private cleanupZoomListener: () => void = () => {};
  pageReady = false;
  paymethods: PaymentMethod[] | undefined = [];
  accountDetail: AccountDetail = new AccountDetail();
  userProfile?: UserProfile;
  paymentAmounts: any[] = [];
  paymentForm: FormGroup;
  pageLabels$!: Observable<any>;
  pageLabels: any = {};
  isBrowser = false;
  canSchedulePayment = false;
  todaysDay: string = formatDate(new Date(), 'MM/dd/yyy', 'en-us');
  formErrorMessage?: string = '';
  showBill = false;
  showTermsConditions = false;
  paySummaryMethodLabel = '';
  applePayURL = '';
  paymentErrors: any[] = [];
  disableDigitalPayments: boolean = false;
  @ViewChild('payAmount') payAmountEl!: HTMLElement;
  @ViewChild('datepickerFooter') datepickerFooter!: ElementRef;
  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    // Only highligh dates inside the month view.
    if (view === 'month') {
      const date = cellDate.toLocaleDateString();
      if (!this.accountDetail.IsPayPlan) {
        const billDueDate = toDate(this.accountDetail.CurrentBalanceDueDate!).toLocaleDateString();
        // Highlight the bill due date day
        return date === billDueDate ? 'gs-custom-date-class' : '';
      } else if (this.accountDetail.IsPayPlan) {
        let payPlanDueDate: Date | undefined = this.accountDetail.PaymentPlans?.find(
          (x) => toDate(x.DueDate!) > this.minDate && toDate(x.DueDate!) < addDays(this.minDate, 30),
        )?.DueDate;
        if (payPlanDueDate !== undefined) {
          payPlanDueDate = toDate(payPlanDueDate);
          // Highlight the payplan due date day
          return date === payPlanDueDate.toLocaleDateString() ? 'gs-custom-date-class' : '';
        }
      }
    }
    return '';
  };

  minDate = new Date();
  maxDate?: Date;
  startDate = this.minDate;
  calendarLegendDueDateText = '';
  calendarLegendSelectedPayDateText = '';
  calendarLegendSelectedDueDateText = '';
  selectedPaymethodType = '';
  emailFormData: any = {};
  hasEmail = false;
  headlineCodeCheck = false;
  pageName = 'Payment';
  headerData = new PageHeader();
  showEmail = true;

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    public dialog: MatDialog,
    private readonly utils: UtilService,
    private readonly payment: PaymentService,
    private readonly paymentus: PaymentusService,
    private readonly storage: StorageService,
    private readonly fb: FormBuilder,
    private readonly cms: CmsService,
    private readonly router: Router,
    private readonly currencyP: CurrencyPipe,
    private readonly creditP: CreditPipe,
    private readonly decimalPipe: DecimalPipe,
    private readonly account: AccountService,
    private readonly customer: CustomerService,
    private readonly notifi: NotificationsService,
    private readonly seoS: SeoService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
      this.userProfile = this.storage.getSession(StorageEnum.LoginResponse);
      this.paymentErrors = this.storage.getSession(StorageEnum.GlobalVars)?.paymentErrors;
    }
    this.paymentForm = this.fb.group({
      paydate: ['', [Validators.required, this.validatePaymentDate.bind(this)]],
      paymethod: this.fb.control<PaymentMethod | null>(null, [Validators.required]),
      payamount: [null, [Validators.required]],
      otheramount: [null],
      termsConditionsChkbox: [false, [Validators.required]],
    });
    this.paymentForm.get('otheramount')?.disable();
    this.paymentForm.setValidators(OtherAmountValidator());
    this.headlineCodeCheck = this.accountDetail.HeadlineCode === '25' || this.accountDetail.HeadlineCode === '120';
    this.disableDigitalPayments = this.storage.getSession(StorageEnum.GlobalVars)?.disableDigitalPayments;
  }

  ngOnInit(): void {
    this.cms
      .getContent('oas-payment', 'Payment')
      .pipe(
        map((data) => {
          const labelList: any = [];
          const dataCopy = JSON.parse(JSON.stringify(data));

          data.paymentSuccessLabelsList.forEach((label: any) => {
            labelList.push({ name: label.labels.value.name, data: label.labels.value.data });
          });
          dataCopy.paymentSuccessLabelsList = labelList;
          return dataCopy;
        }),
        concatMap((data) => {
          this.pageLabels = data;
          this.headerData.Message = this.pageLabels.paymentHeaderText;
          this.seoS.setSeoTags(data.seo);

          if (this.isBrowser) {
            this.getPaymentOptions();
            this.checkFuturePaymentEligibility();
            this.displayPaymentPreNotifications();
            this.setupFuturePaymentDateCalendar();
            return this.payment.getPreferredPayments(this.accountDetail);
          } else {
            return EMPTY;
          }
        }),
      )
      .subscribe((data: any) => {
        this.storage.setSession(StorageEnum.PaymentMethods, data.PaymentMethods);

        if (!data.PaymentMethods) {
          data.PaymentMethods = [];
        }

        this.addNewCardAndBankOptions(data.PaymentMethods);
        this.paymethods = this.payment.sortPaymentMethods(
          data.PaymentMethods,
          this.disableDigitalPayments,
          this.accountDetail.IsLimitedPaymentOptions,
        );
        this.hasEmail =
          this.accountDetail?.Person?.EmailAddresses?.find((email: EmailInfo) => {
            return email.IsPrimary && email.Type?.toUpperCase() === 'EMAIL';
          })?.IsPrimary ?? false;
        if (!this.hasEmail) {
          this.setupEmailData();
        }
        this.utils.hideSpinner();
        this.pageReady = true;
      });
    this.setShowBill();
  }

  setupFuturePaymentDateCalendar(): void {
    if (!this.accountDetail.IsPayPlan) {
      // if bill due date + 14 days is greater than 30 days from today, set max payment date to today + 30 days
      if (addDays(this.accountDetail.CurrentBalanceDueDate!, 14) > addDays(this.minDate, 30)) {
        this.maxDate = addDays(this.minDate, 30);
      } else {
        this.maxDate = addDays(this.accountDetail.CurrentBalanceDueDate!, 14);
      }
      this.calendarLegendDueDateText = this.pageLabels.calendarLegendBillDueDateText.replace(
        '{0}',
        format(this.accountDetail.CurrentBalanceDueDate!, 'MMM dd, yyyy'),
      );
      this.calendarLegendSelectedPayDateText = this.pageLabels.calendarLegendSelectedPayDateText;
      this.calendarLegendSelectedDueDateText = this.pageLabels.calendarLegendSelectedDateDueDateText;
    }
    if (this.accountDetail.IsPayPlan && this.accountDetail.PaymentPlans) {
      const maxDate = this.accountDetail.PaymentPlans?.find(
        (x) => toDate(x.DueDate!) > this.minDate && toDate(x.DueDate!) < addDays(this.minDate, 30),
      )?.DueDate;
      if (maxDate !== undefined) {
        this.maxDate = maxDate;
      } else {
        this.canSchedulePayment = false;
        // default payment date to today if no date in form model or not eligible for future payment
        this.paymentForm.get('paydate')?.setValue(this.todaysDay);
        return;
      }

      // maxDate = new Date(this.findEligiblePayPlanDate(this.accountSummary.PayPlans));
      this.calendarLegendDueDateText = this.pageLabels.calendarLegendPayPlanDueDateText;
      this.calendarLegendSelectedPayDateText = this.pageLabels.calendarLegendSelectedPayDateText;
      this.calendarLegendSelectedDueDateText = this.pageLabels.calendarLegendSelectedPayPlanDueDateText;
    }
    const endOfMonthDay = format(endOfMonth(this.minDate), 'MM/dd/yyyy');
    const startDateDay = format(this.startDate, 'MM/dd/yyyy');
    // If current day is end of month default start date on calendar to be
    // first day of the next month.
    if (endOfMonthDay === startDateDay) {
      this.startDate = addDays(this.startDate, 1);
    }
  }

  /**
   * returns payplan due date that is within next 30 days
   * @param payPlans
   * @returns eligible date string or undefined if not found
   */
  findEligiblePayPlanDate(payPlans: any[]): Date {
    return payPlans.find((x) => x.DueDate > this.minDate && x.DueDate < addDays(this.minDate, 30))?.DueDate;
  }

  onCalendarOpen(picker: MatDatepicker<Date>): void {
    this.cleanupZoomListener = this.utils.attachDatepickerZoomListener(picker);
    this.appendFooter();
    this.announceCalendarLegend();
    if (typeof document !== 'undefined') {
      setTimeout(() => {
        const matDatePickerChild = document.getElementsByClassName('gs-custom-date-class')[0];
        const ariaLabelText = 'Selected Date is the due date';
        matDatePickerChild?.setAttribute('aria-label', ariaLabelText);
      }, 10);
    }
  }

  private appendFooter(): void {
    if (!this.isBrowser || typeof document === 'undefined') {
      return;
    }

    const matCalendar = document.getElementsByClassName('mat-datepicker-content')[0] as HTMLElement | undefined;
    if (!matCalendar) {
      return;
    }

    matCalendar.appendChild(this.datepickerFooter.nativeElement);
    matCalendar.setAttribute('aria-describedby', 'calendarLegendSrText');
  }

  private announceCalendarLegend(): void {
    if (typeof document === 'undefined') {
      return;
    }

    const legendDescription = document.getElementById('calendarLegendSrText');
    const textToAnnounce = legendDescription?.textContent;

    if (!legendDescription || !textToAnnounce) {
      return;
    }

    // Re-injecting the same text prompts screen readers to announce this live region when the calendar opens.
    legendDescription.textContent = '';
    setTimeout(() => {
      legendDescription.textContent = textToAnnounce;
    }, 25);
  }

  onCalendarClosed(): void {
    this.cleanupZoomListener();
  }

  setShowBill(): void {
    this.showBill = false;
    if (this.accountDetail?.Bills && this.accountDetail?.Bills?.length > 0) {
      const bill = this.accountDetail.Bills[0];
      if (bill.ExtractedDate) {
        const dateToShowBill = format(add(bill.ExtractedDate, { days: 3 }), 'MM/dd/yyyy');
        const today = new Date();
        const dateIsEqual = isEqual(today, dateToShowBill);
        const dateIsAfter = isAfter(today, dateToShowBill);
        if (dateIsEqual || dateIsAfter) {
          this.showBill = true;
        }
      }
    }
  }

  checkOtherAmount(): void {
    if (this.paymentForm.get('payamount')?.value === 'other') {
      this.paymentForm.get('otheramount')?.enable();
    } else {
      this.paymentForm.get('otheramount')?.disable();
    }
  }

  otherClicked(): void {
    const payamountVal = this.paymentForm.get('payamount');
    if (payamountVal?.value !== 'other') {
      payamountVal?.patchValue('other');
      this.checkOtherAmount();
    }
  }

  openCreditCardForm(): void {
    const dialogRef = this.dialog.open(CreditCardFormComponent, {
      ariaLabel: 'Credit Card',
      disableClose: true,
      autoFocus: 'first-heading',
      panelClass: 'gs-dialog',
      data: { payMethod: this.paymentForm.get('paymethod')?.value, parentForm: 'payment' },
    });

    dialogRef.afterClosed().subscribe((result: PaymentDialogResult) => {
      this.utils.showSpinner();
      if (result.Type === DialogResultType.Cancel) {
        this.paymentForm.patchValue({ paymethod: null });
        this.paySummaryMethodLabel = '';
        this.utils.hideSpinner();
      } else if (result.Type === DialogResultType.Update) {
        // Find Record in the List and Update it
        this.paymethods = this.paymethods?.map((pm) =>
          pm.ReferenceId === result.PayMethod.ReferenceId ? result.PayMethod : pm,
        );
        // select Update record
        if (!this.utils.isNullOrWhitespace(result.PayMethod.ReferenceId)) {
          const newSelectedMethod = this.paymethods?.find((pm) => {
            return pm.ReferenceId === result.PayMethod.ReferenceId;
          });
          this.paymentForm.patchValue({ paymethod: newSelectedMethod });
          this.setPaySummaryMethodLabel();
        }
      } else if (result.Type === DialogResultType.Add) {
        this.payment.addNewPayMethod(this.paymethods!, result.PayMethod);
        this.paymethods = this.payment.sortPaymentMethods(
          this.paymethods!,
          this.disableDigitalPayments,
          this.accountDetail.IsLimitedPaymentOptions,
        );
        if (!this.utils.isNullOrWhitespace(result.PayMethod.ReferenceId)) {
          const newSelectedMethod = this.paymethods.find((pm) => {
            return pm.ReferenceId === result.PayMethod.ReferenceId;
          });
          this.paymentForm.patchValue({ paymethod: newSelectedMethod });
          this.setPaySummaryMethodLabel();
        }
      } else if (result.Type === DialogResultType.Error) {
        this.paymentForm.patchValue({ paymethod: null });
        this.paySummaryMethodLabel = '';
        this.showFormErrorLabel(result.ErrorMessage);
        this.utils.hideSpinner();
      }
      this.storage.setSession(StorageEnum.PaymentMethods, this.paymethods);
      this.utils.hideSpinner();
    });
  }

  openBankAccountForm(): void {
    const dialogRef = this.dialog.open(BankAccountFormComponent, {
      ariaLabel: 'Bank Account',
      disableClose: true,
      autoFocus: 'first-heading',
      panelClass: 'gs-dialog',
      data: 'payment',
    });

    dialogRef.afterClosed().subscribe((result: PaymentDialogResult) => {
      if (result.Type === DialogResultType.Cancel) {
        this.paymentForm.patchValue({ paymethod: null });
        this.paySummaryMethodLabel = '';
        this.utils.hideSpinner();
      } else if (result.Type === DialogResultType.Add) {
        this.payment.addNewPayMethod(this.paymethods!, result.PayMethod);
        this.paymethods = this.payment.sortPaymentMethods(
          this.paymethods!,
          this.disableDigitalPayments,
          this.accountDetail.IsLimitedPaymentOptions,
        );
        this.storage.setSession(StorageEnum.PaymentMethods, this.paymethods);
        if (!this.utils.isNullOrWhitespace(result.PayMethod.ReferenceId)) {
          const newSelectedMethod = this.paymethods.find((pm) => {
            return pm.ReferenceId === result.PayMethod.ReferenceId;
          });
          this.paymentForm.patchValue({ paymethod: newSelectedMethod });
          this.setPaySummaryMethodLabel();
        }
      } else if (result.Type === DialogResultType.Error) {
        this.paymentForm.patchValue({ paymethod: null });
        this.paySummaryMethodLabel = '';
        this.showFormErrorLabel(result.ErrorMessage);
        this.utils.hideSpinner();
      }
      this.utils.hideSpinner();
    });
  }

  addNewCardAndBankOptions(paymethodsList: PaymentMethod[]): void {
    this.payment.addNewCardAndBankToPaymethodList(
      paymethodsList,
      this.pageLabels.paymentMethodNewBankText,
      this.pageLabels.paymentMethodNewCardText,
    );

    const cashCheckPayment = new PaymentMethod();
    cashCheckPayment.PaymentAccountType = PaymentAccountType.Cash;
    cashCheckPayment.Description = this.pageLabels.payMethodCashText;
    paymethodsList.push(cashCheckPayment);
  }

  checkFuturePaymentEligibility(): void {
    this.canSchedulePayment = this.payment.isEligibleForFuturePayment(this.accountDetail);

    const profile = this.userProfile?.Accounts[0].ServiceAddresses[0];

    if (profile?.SaStatusFlag === '40') {
      this.canSchedulePayment = false; // Can not schedule FDP for Stopped (40) accounts
    }

    if (!this.canSchedulePayment) {
      // default payment date to today if no date in form model or not eligible for future payment
      this.paymentForm.get('paydate')?.setValue(this.todaysDay);
    }
  }

  displayPaymentPreNotifications(): void {
    // this.notifi.clearAllNotifications();
    if (this.accountDetail.HeadlineCode === '25') {
      this.notifi.addNotification(this.pageLabels.headline25PreNotificationText, NotificationType.Alert, this.pageName);
    }

    if (this.accountDetail.IsLimitedPaymentOptions) {
      this.notifi.addNotification(
        this.pageLabels.limitedPaymentOptionsPreNotification,
        NotificationType.Alert,
        this.pageName,
      );
    }

    const balance = this.accountDetail?.CurrentBalance ?? 0;
    if (this.accountDetail.IsAutoPay && balance > 0) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
      const autoPayDate = formatDate(this.accountDetail.CurrentBalanceDueDate!, 'MM/dd/yyy', 'en-us');

      if (autoPayDate > this.todaysDay) {
        this.pageLabels.accountIsOnAutoPayPreNotification = this.pageLabels.accountIsOnAutoPayPreNotification.replace(
          '{{date}}',
          autoPayDate,
        );
        this.pageLabels.accountIsOnAutoPayPreNotification = this.pageLabels.accountIsOnAutoPayPreNotification.replace(
          '{{$}}',
          '$' + this.accountDetail.CurrentBalance,
        );
        this.notifi.addNotification(
          this.pageLabels.accountIsOnAutoPayPreNotification,
          NotificationType.Alert,
          this.pageName,
        );
      }
    }

    if (this.accountDetail.FuturePayment?.Info?.PaymentDate && this.accountDetail.FuturePayment?.Info?.PaymentAmount) {
      const futurePaymentDate = formatDate(this.accountDetail.FuturePayment?.Info?.PaymentDate, 'MM/dd/yyy', 'en-us');
      const futurePaymentAmount = this.accountDetail.FuturePayment.Info?.PaymentAmount;
      this.pageLabels.futurePaymentScheduledPreNotification =
        this.pageLabels.futurePaymentScheduledPreNotification.replace('{{date}}', futurePaymentDate);
      this.pageLabels.futurePaymentScheduledPreNotification =
        this.pageLabels.futurePaymentScheduledPreNotification.replace('{{$}}', '$' + futurePaymentAmount);
      this.notifi.addNotification(
        this.pageLabels.futurePaymentScheduledPreNotification,
        NotificationType.Alert,
        this.pageName,
      );
    }
  }

  validatePaymentDate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) {
      return { required: true };
    }
    return null;
  }

  payDateChange(event: any): void {
    const dateValue: Date = event.value;
    const selectedDateIsFuture = isFuture(dateValue);
    if (selectedDateIsFuture) {
      this.showTermsConditions = true;
    } else {
      this.showTermsConditions = false;
    }
    this.startDate = dateValue;
    if (typeof document !== 'undefined') {
      const matTogglerChild = document.querySelector('mat-datepicker-toggle')?.firstElementChild;
      if (toDate(this.accountDetail.CurrentBalanceDueDate!).toString() === toDate(dateValue).toString()) {
        const ariaLabelText =
          this.pageLabels.calendarCurrentDateDueDateAriaLabelText + format(dateValue, 'MMM dd, yyyy');
        matTogglerChild?.setAttribute('aria-label', ariaLabelText);
      } else {
        const ariaLabelText =
          this.pageLabels.calendarSelectedPaymentDateAriaLabelText + format(dateValue, 'MMM dd, yyyy');
        matTogglerChild?.setAttribute('aria-label', ariaLabelText);
      }
    }
  }

  validateTermsConditions(): void {
    if (this.canSchedulePayment && this.showTermsConditions) {
      if (!this.paymentForm.value.termsConditionsChkbox) {
        const termsCond = this.paymentForm.get('termsConditionsChkbox');
        if (termsCond) {
          termsCond.setErrors({ termsConditionsError: true });
        }
      }
    }
  }

  setPaySummaryMethodLabel(): void {
    if (this.paymentForm.get('paymethod')?.value?.Nickname) {
      if (this.paymentForm.get('paymethod')?.value?.LastFour) {
        this.paySummaryMethodLabel =
          this.paymentForm.get('paymethod')?.value?.Nickname +
          ' ending in ' +
          this.paymentForm.get('paymethod')?.value?.LastFour;
      } else {
        this.paySummaryMethodLabel = this.paymentForm.get('paymethod')?.value?.Nickname;
      }
    } else {
      this.paySummaryMethodLabel = this.paymentForm.get('paymethod')?.value?.Description;
    }
  }

  paymethodChanged(): void {
    this.showEmail = true;
    this.setPaySummaryMethodLabel();
    const selectedPaymethod: PaymentMethod = this.paymentForm.get('paymethod')?.value;
    this.selectedPaymethodType = this.payment.isCardBankDigital(selectedPaymethod.PaymentAccountType);
    if (this.selectedPaymethodType === 'BANK') {
      if (!selectedPaymethod.ReferenceId) {
        this.openBankAccountForm();
      }
    } else if (this.selectedPaymethodType === 'DIGITAL') {
      if (!selectedPaymethod.ReferenceId) {
        this.openDigitalPayment(selectedPaymethod.PaymentAccountType!);
      }
    } else if (this.selectedPaymethodType === 'CARD') {
      this.openCreditCardForm();
    } else if (this.selectedPaymethodType === 'CASH') {
      this.showEmail = false;
      this.utils.consoleLog('cash money');
    } else {
      this.utils.consoleLog(`selectedPaymethodType: ${this.selectedPaymethodType}`);
    }
    this.payAmountNotifications();
  }

  openDigitalPayment(paymentType: PaymentAccountType): void {
    const page = window.location.origin + '/payment';
    // Detect platform for mobile redirect flow
    const platform = Capacitor.isNativePlatform() ? (Capacitor.getPlatform() as 'ios' | 'android') : undefined;
    this.paymentus
      .getDigitalPaymentToken(this.accountDetail?.AccountNumber, paymentType, page, platform)
      .pipe(
        catchError((dataError: any) => {
          void this.router.navigateByUrl(Nav.ErrorPage);
          return throwError(() => new Error(dataError));
        }),
        concatMap((data: string) => {
          const url = environment.paymentusDigitalTokenUrl() + '?authToken=' + data;
          return this.createIframe(url, page, paymentType);
        }),
      )
      .subscribe((result: PaymentDialogResult) => {
        if (result.Type === DialogResultType.Add) {
          this.paymethods?.push(result.PayMethod);
          this.paymethods = this.payment.sortPaymentMethods(
            this.paymethods!,
            this.disableDigitalPayments,
            this.accountDetail.IsLimitedPaymentOptions,
          );
          if (!this.utils.isNullOrWhitespace(result.PayMethod.ReferenceId)) {
            const newSelectedMethod = this.paymethods.find((pm) => {
              return pm.ReferenceId === result.PayMethod.ReferenceId;
            });
            this.paymentForm.patchValue({ paymethod: newSelectedMethod });
            this.setPaySummaryMethodLabel();
          }
        } else if (result.Type === DialogResultType.Cancel) {
          this.paymentForm.patchValue({ paymethod: null });
          this.paySummaryMethodLabel = '';
          this.utils.hideSpinner();
        }
        this.utils.hideSpinner();
      });
  }

  createIframe(url: string, page: string, paymentAccountType: PaymentAccountType): Observable<any> {
    const dialogRef = this.dialog.open(DigitalPaymentModalComponent, {
      ariaLabel: paymentAccountType.toString(),
      disableClose: true,
      autoFocus: 'first-heading',
      panelClass: 'gs-dialog',
      data: {
        url,
        page,
        paymentAccountType,
        callbackUrlPattern: environment.digitalPaymentCallbackPath,
      },
      height: '500px',
      width: '500px',
    });

    return dialogRef.afterClosed();
  }

  payAmountNotifications(): void {
    this.notifi.deleteNotification(this.pageLabels.maxBankAmountPostNotification);
    this.notifi.deleteNotification(this.pageLabels.maxCardAmountPostNotification);
    const payType = this.paymentForm.get('paymethod')?.value?.PaymentAccountType ?? PaymentAccountType.Unknown;
    const totalBalance = this.accountDetail?.CurrentBalance ?? 0;
    if (payType === PaymentAccountType.Banking && totalBalance > 1000000) {
      this.notifi.addNotification(this.pageLabels.maxBankAmountPostNotification, NotificationType.Alert, this.pageName);
    }

    if (
      payType !== PaymentAccountType.Unknown &&
      payType !== PaymentAccountType.Banking &&
      payType !== PaymentAccountType.Cash &&
      totalBalance > 50000
    ) {
      this.notifi.addNotification(this.pageLabels.maxCardAmountPostNotification, NotificationType.Alert, this.pageName);
    }
  }

  getPaymentOptions(): void {
    const current = this.accountDetail?.CurrentBalance ?? 0;
    const pastDue = this.accountDetail?.PastDueBalance ?? 0;
    const minDue = this.accountDetail?.MinimumPayment ?? 0;
    const isLiheap = this.accountDetail?.PayPlanType?.toUpperCase() === 'LIHEAP';
    this.paymentAmounts = [];

    if (current <= 0) {
      this.paymentAmounts.push({
        label: this.pageLabels.payAmountTotalLabel,
        amount: current,
        disable: true,
        tooltip: this.pageLabels.payAmountTotalTooltip,
      });
      this.otherClicked();
    } else {
      // check for specific headline codes
      if (this.headlineCodeCheck) {
        if (current !== pastDue) {
          this.paymentAmounts.push({
            label: this.pageLabels.payAmountTotalLabel,
            amount: current,
            disable: false,
            tooltip: this.pageLabels.payAmountTotalTooltip,
          });
        }
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountPastDueLabel,
          amount: pastDue,
          disable: false,
          tooltip: this.pageLabels.payAmountPastDueTooltip,
        });
      } else if (current === minDue && minDue === pastDue) {
        // show min Due
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountMinDueLabel,
          amount: minDue,
          disable: false,
          tooltip: this.pageLabels.payAmountMinDueTooltip,
        });
      } else if (current === pastDue && minDue === 0) {
        // show past due
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountPastDueLabel,
          amount: pastDue,
          disable: false,
          tooltip: this.pageLabels.payAmountPastDueTooltip,
        });
      } else if (current === pastDue && pastDue !== minDue) {
        // show pastDue and minDue
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountPastDueLabel,
          amount: pastDue,
          disable: false,
          tooltip: this.pageLabels.payAmountPastDueTooltip,
        });
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountMinDueLabel,
          amount: minDue,
          disable: false,
          tooltip: this.pageLabels.payAmountMinDueTooltip,
        });
      } else if (current !== pastDue && pastDue === minDue && minDue > 0) {
        // show current and min
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountTotalLabel,
          amount: current,
          disable: false,
          tooltip: this.pageLabels.payAmountTotalTooltip,
        });
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountMinDueLabel,
          amount: minDue,
          disable: false,
          tooltip: this.pageLabels.payAmountMinDueTooltip,
        });
      } else if (current !== pastDue && pastDue !== minDue) {
        // show total,  pastDue and minDue
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountTotalLabel,
          amount: current,
          disable: false,
          tooltip: this.pageLabels.payAmountTotalTooltip,
        });
        if (pastDue > 0) {
          this.paymentAmounts.push({
            label: this.pageLabels.payAmountPastDueLabel,
            amount: pastDue,
            disable: false,
            tooltip: this.pageLabels.payAmountPastDueTooltip,
          });
        }
        if (minDue > 0) {
          this.paymentAmounts.push({
            label: this.pageLabels.payAmountMinDueLabel,
            amount: minDue,
            disable: false,
            tooltip: this.pageLabels.payAmountMinDueTooltip,
          });
        }
      } else {
        // show current
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountTotalLabel,
          amount: current,
          disable: false,
          tooltip: this.pageLabels.payAmountTotalTooltip,
        });
      }

      if (this.accountDetail.IsPayPlan) {
        if (isLiheap) {
          this.paymentAmounts.push({
            label: this.pageLabels.payAmountEapLabel,
            amount: this.accountDetail.PaymentPlans ? this.accountDetail.PaymentPlans[0].AmountDue : 0,
            disable: false,
            tooltip: this.pageLabels.payAmountEapTooltip,
          });
        } else {
          this.paymentAmounts.push({
            label: this.pageLabels.payAmountPayPlanLabel,
            amount: this.accountDetail.PaymentPlans ? this.accountDetail.PaymentPlans[0].AmountDue : 0,
            disable: false,
            tooltip: this.pageLabels.payAmountPayPlanTooltip,
          });
        }
      }
      // Set Pay Amount to first item in the list, since we are Selecting it by default.
      // so Pay button in Summary section will have amount populated
      this.paymentForm.get('payamount')?.setValue(this.paymentAmounts[0].amount);
    }
  }

  showFormErrorLabel(errorMessage?: string): void {
    this.formErrorMessage = errorMessage;
    if (this.formErrorMessage && this.formErrorMessage !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }

  onSubmit(): void {
    const payDate = this.paymentForm.get('paydate')?.value;
    this.formErrorMessage = '';
    this.paymentForm.markAllAsTouched();
    this.validateTermsConditions();
    if (this.paymentForm.valid) {
      this.utils.showSpinner();
      if (!this.hasEmail) {
        // handle new email stuff
        // according to ticket, even if this call fails we continue with payment, so we don't really need to do anything with the response
        if (this.emailFormData.formGroup.valid) {
          const emailValue = this.emailFormData.formGroup.value.email;

          const personRequest = this.accountDetail?.Person;
          const email = new EmailInfo();
          email.ContactId = '';
          email.Email = emailValue;
          email.IsActive = true;
          email.IsPrimary = true;
          email.Type = 'EMAIL';
          personRequest?.EmailAddresses?.push(email);
          this.account.UpdatePersonContact(personRequest).subscribe({
            error: (e) => {
              this.utils.consoleLog('There was an error adding email on payments page. Error: ' + e);
            },
            next: (data: any) => {
              this.accountDetail.Person = data;
              this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
              this.hasEmail = true;
            },
          });
        } else {
          const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
          this.emailFormData.formGroup.markAllAsTouched();
          this.showFormErrorLabel(errorMessage);
          this.utils.hideSpinner();
          return;
        }
      }
      const payDateTime = new Date(payDate).getTime();
      const todayDateTime = new Date(this.todaysDay).getTime();
      if (payDateTime > todayDateTime) {
        this.makeFuturePayment();
      } else if (this.paymentForm.get('paymethod')?.value?.PaymentAccountType !== PaymentAccountType.Banking) {
        this.makeCardPayment();
      } else {
        this.makeBankPayment();
      }
    } else {
      const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
      this.showFormErrorLabel(errorMessage);
    }
  }

  setSuccessData(payRequest: BankPayment, payResponse: PaymentResponse): void {
    if (this.accountDetail.HeadlineCode === '25' && payResponse.PastDueBalance! <= 5) {
      this.createToDo();
      this.createCustomerContact();
    }
    let cta = new CTA();
    let paymentCTA;
    const successLabels = this.pageLabels.paymentSuccessLabelsList.find((labels: any) => {
      return labels.name === 'PaymentSuccess';
    }).data;
    const email =
      this.accountDetail.Person?.EmailAddresses?.find((email: EmailInfo) => {
        return email.IsPrimary;
      })?.Email ?? '';
    const success = new SuccessData();
    success.Header = successLabels.header;
    success.Subheader = successLabels.subheaderText.replace('{0}', email);
    success.PaymentAmount.Label = successLabels.paymentAmountLabel;
    success.PaymentAmount.Value = payRequest.Amount!;
    if (this.selectedPaymethodType === 'DIGITAL') {
      const selectedPaymethod = this.paymentForm.get('paymethod')?.value;
      success.Details.push({
        Label: successLabels.details[0].detailLabel,
        Value: `${selectedPaymethod.PaymentAccountType}`,
      });
    } else {
      success.Details.push({
        Label: successLabels.details[0].detailLabel,
        Value: this.payment.getPaymethodDescription(
          payRequest.PaymentAccountType as PaymentAccountType,
          payRequest.LastFour,
          payRequest.Nickname,
        ),
      });
    }
    success.Details.push({ Label: successLabels.details[1].detailLabel, Value: `${payResponse.ConfirmationNumber}` });
    success.Details.push({
      Label: successLabels.details[2].detailLabel,
      Value: `${this.creditP.transform(this.currencyP.transform(payResponse.CurrentBalance))}`,
    });

    // Only display AutoPay sign up link if account is Not on AutoPay
    if (!this.accountDetail.IsAutoPay) {
      success.LinkList.push({
        Label: successLabels.linkList[0].linkLabel,
        Link: successLabels.linkList[0].linkUrl,
        AriaLabel: successLabels.linkList[0].linkAltText,
      });
    }
    // Create post notification messages and CTA buttons for specific headline codes
    // Headline 50 logic
    if (this.accountDetail.HeadlineCode === '50') {
      if (payResponse.PastDueBalance! <= 5) {
        const pastDueNotification = successLabels.postNotificationList.find((message: any) => {
          return message.messageId === 'pastDueLessThanEqualFiveHL50';
        });
        success.PostNotificationList.push({
          Message: pastDueNotification.message,
          NotificationType: NotificationType.Prenotification,
        });
        paymentCTA = successLabels.ctaList.find((cta: any) => {
          return cta.ctaId === 'accountSummary';
        });
        cta.Label = paymentCTA.ctaLabel;
        cta.AriaLabel = paymentCTA.ctaAriaLabel;
        cta.Link = paymentCTA.ctaUrl;
        success.CTAList.push(cta);
      } else if (payResponse.PastDueBalance! > 5) {
        const pastDueNotification = successLabels.postNotificationList.find((message: any) => {
          return message.messageId === 'pastDueGreaterThanFiveHL50';
        });
        success.PostNotificationList.push({
          Message: pastDueNotification.message.replace(
            '{0}',
            `${this.creditP.transform(this.currencyP.transform(payResponse.PastDueBalance))}`,
          ),
          NotificationType: NotificationType.Alert,
        });
        paymentCTA = successLabels.ctaList.find((cta: any) => {
          return cta.ctaId === 'payment';
        });
        cta.Label = paymentCTA.ctaLabel;
        cta.AriaLabel = paymentCTA.ctaAriaLabel;
        cta.Link = paymentCTA.ctaUrl;
        success.CTAList.push(cta);
      }
      // Headline 25 logic
    } else if (this.accountDetail.HeadlineCode === '25') {
      if (payResponse.PastDueBalance! <= 5) {
        const pastDueNotification = successLabels.postNotificationList.find((message: any) => {
          return message.messageId === 'pastDueLessThanEqualFiveHL25';
        });
        success.PostNotificationList.push({
          Message: pastDueNotification.message,
          NotificationType: NotificationType.Prenotification,
        });
        paymentCTA = successLabels.ctaList.find((cta: any) => {
          return cta.ctaId === 'accountSummary';
        });
        cta.Label = paymentCTA.ctaLabel;
        cta.AriaLabel = paymentCTA.ctaAriaLabel;
        cta.Link = paymentCTA.ctaUrl;
        success.CTAList.push(cta);
      } else if (payResponse.PastDueBalance! > 5) {
        const pastDueNotification = successLabels.postNotificationList.find((message: any) => {
          return message.messageId === 'pastDueGreaterThanFiveHL25';
        });

        success.PostNotificationList.push({
          Message: pastDueNotification.message.replace(
            '{0}',
            `${this.creditP.transform(this.currencyP.transform(payResponse.PastDueBalance))}`,
          ),
          NotificationType: NotificationType.Alert,
        });
        paymentCTA = successLabels.ctaList.find((cta: any) => {
          return cta.ctaId === 'payment';
        });
        cta.Label = paymentCTA.ctaLabel;
        cta.AriaLabel = paymentCTA.ctaAriaLabel;
        cta.Link = paymentCTA.ctaUrl;
        success.CTAList.push(cta);
      }
      // Headline 110 logic
    } else if (this.accountDetail.HeadlineCode === '110') {
      const pastDueNotification = successLabels.postNotificationList.find((message: any) => {
        return message.messageId === 'pastDueMustPayHL110';
      });
      success.PostNotificationList.push({
        Message: pastDueNotification.message,
        NotificationType: NotificationType.Prenotification,
      });
      paymentCTA = successLabels.ctaList.find((cta: any) => {
        return cta.ctaId === 'startService';
      });
      cta.Label = paymentCTA.ctaLabel;
      cta.AriaLabel = paymentCTA.ctaAriaLabel;
      cta.Link = paymentCTA.ctaUrl;
      success.CTAList.push(cta);
      paymentCTA = successLabels.ctaList.find((cta: any) => {
        return cta.ctaId === 'accountSummary';
      });
      cta = new CTA();
      cta.Label = paymentCTA.ctaLabel;
      cta.AriaLabel = paymentCTA.ctaAriaLabel;
      cta.Link = paymentCTA.ctaUrl;
      success.CTAList.push(cta);
      // Headline 120 logic
    } else if (
      this.accountDetail.HeadlineCode === '120' &&
      this.accountDetail.CustomerClass !== CustomerClassEnum.LRGCOM
    ) {
      const inInterval = isWithinInterval(new Date(this.userProfile?.Accounts[0].ServiceAddresses[0].SaEndDate ?? ''), {
        start: subDays(new Date(), 90),
        end: new Date(),
      });
      if (inInterval) {
        const pastDueNotification = successLabels.postNotificationList.find((message: any) => {
          return message.messageId === 'pastDueMustPayHL120';
        });
        // Only show Reconnect CTA and Message If Total Balance was paid off
        if (payResponse.CurrentBalance! === 0) {
          success.PostNotificationList.push({
            Message: pastDueNotification.message,
            NotificationType: NotificationType.Prenotification,
          });
          paymentCTA = successLabels.ctaList.find((cta: any) => {
            return cta.ctaId === 'reconnectService';
          });
          cta.Label = paymentCTA.ctaLabel;
          cta.AriaLabel = paymentCTA.ctaAriaLabel;
          cta.Link = paymentCTA.ctaUrl;
          success.CTAList.push(cta);
        }
      }
      paymentCTA = successLabels.ctaList.find((cta: any) => {
        return cta.ctaId === 'accountSummary';
      });
      cta = new CTA();
      cta.Label = paymentCTA.ctaLabel;
      cta.AriaLabel = paymentCTA.ctaAriaLabel;
      cta.Link = paymentCTA.ctaUrl;
      success.CTAList.push(cta);
      // Headline 130 logic
    } else if (this.accountDetail.HeadlineCode === '130') {
      const notPastDueFinalBillNotification = successLabels.postNotificationList.find((message: any) => {
        return message.messageId === 'notPastDueFinalBillHL130';
      });
      success.PostNotificationList.push({
        Message: notPastDueFinalBillNotification.message,
        NotificationType: NotificationType.Prenotification,
      });
      paymentCTA = successLabels.ctaList.find((cta: any) => {
        return cta.ctaId === 'reconnectService';
      });
      cta.Label = paymentCTA.ctaLabel;
      cta.AriaLabel = paymentCTA.ctaAriaLabel;
      cta.Link = paymentCTA.ctaUrl;
      success.CTAList.push(cta);
      paymentCTA = successLabels.ctaList.find((cta: any) => {
        return cta.ctaId === 'accountSummary';
      });
      cta = new CTA();
      cta.Label = paymentCTA.ctaLabel;
      cta.AriaLabel = paymentCTA.ctaAriaLabel;
      cta.Link = paymentCTA.ctaUrl;
      success.CTAList.push(cta);
      // Headline 30 logic
    } else if (this.accountDetail.HeadlineCode === '30') {
      if (payResponse.MinimumPayment! > 0) {
        const minDueGreaterThanZeroNotification = successLabels.postNotificationList.find((message: any) => {
          return message.messageId === 'minDueGreaterThanZeroNotificationHL30';
        });

        success.PostNotificationList.push({
          Message: minDueGreaterThanZeroNotification.message.replace(
            '{0}',
            `${this.creditP.transform(this.currencyP.transform(payResponse.MinimumPayment))}`,
          ),
          NotificationType: NotificationType.Alert,
        });

        paymentCTA = successLabels.ctaList.find((cta: any) => {
          return cta.ctaId === 'payment';
        });
        cta.Label = paymentCTA.ctaLabel;
        cta.AriaLabel = paymentCTA.ctaAriaLabel;
        cta.Link = paymentCTA.ctaUrl;
        success.CTAList.push(cta);
      } else if (payResponse.MinimumPayment! === 0) {
        let sonpNotification;
        switch (payResponse.SONPCode) {
          case SONPCode.SONPC:
            sonpNotification = successLabels.postNotificationList.find((message: any) => {
              return message.messageId === 'sonpcNotificationHL30';
            });
            break;
          case SONPCode.SONPNC:
            sonpNotification = successLabels.postNotificationList.find((message: any) => {
              return message.messageId === 'sonpncNotificationHL30';
            });
            break;
          case SONPCode.SONPIP:
            sonpNotification = successLabels.postNotificationList.find((message: any) => {
              return message.messageId === 'sonpipNotificationHL30';
            });
            break;
          case SONPCode.SONPUS:
          case SONPCode.SONPUE:
          case SONPCode.SONPUR:
            sonpNotification = successLabels.postNotificationList.find((message: any) => {
              return message.messageId === 'sonpusSonpueSonpurNotificationHL30';
            });
            break;
          default:
            sonpNotification = successLabels.postNotificationList.find((message: any) => {
              return message.messageId === 'sonpusSonpueSonpurNotificationHL30';
            });
        }
        if (payResponse.SONPCode === SONPCode.SONPC) {
          success.PostNotificationList.push({
            Message: sonpNotification.message,
            NotificationType: NotificationType.Prenotification,
          });
        } else {
          success.PostNotificationList.push({
            Message: sonpNotification.message,
            NotificationType: NotificationType.Alert,
          });
        }
        paymentCTA = successLabels.ctaList.find((cta: any) => {
          return cta.ctaId === 'accountSummary';
        });
        cta.Label = paymentCTA.ctaLabel;
        cta.AriaLabel = paymentCTA.ctaAriaLabel;
        cta.Link = paymentCTA.ctaUrl;
        success.CTAList.push(cta);
      }
    } else {
      // Default CTA button displayed
      paymentCTA = successLabels.ctaList.find((cta: any) => {
        return cta.ctaId === 'accountSummary';
      });
      cta.Label = paymentCTA.ctaLabel;
      cta.AriaLabel = paymentCTA.ctaAriaLabel;
      cta.Link = paymentCTA.ctaUrl;
      success.CTAList.push(cta);
    }

    // Update the account detail headline code from the payresponse
    // After we have used the original one to build the success data.
    this.accountDetail.HeadlineCode = payResponse.HeadlineCode;
    this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
    // put updated data into storage
    this.storage.setSession(StorageEnum.SuccessData, success);
  }

  setFutureDatedPaymentSuccessData(payRequest: Payment, payResponse: FuturePayment): void {
    const successLabels = this.pageLabels.paymentSuccessLabelsList.find((labels: any) => {
      return labels.name === 'FutureDatedPaySuccess';
    }).data;
    const success = new SuccessData();
    success.Header = successLabels.header;
    success.Subheader = successLabels.subheaderText.replace('{0}', '$' + payRequest.Amount);
    success.Subheader = success.Subheader.replace('{1}', format(payRequest.Date!, 'MMMM dd, yyyy'));
    success.PaymentAmount.Label = successLabels.paymentAmountLabel;
    success.PaymentAmount.Value = payRequest.Amount!;
    const confirmationNumber = payResponse.Info?.ReferenceNumber;
    if (this.selectedPaymethodType === 'DIGITAL') {
      const selectedPaymethod = this.paymentForm.get('paymethod')?.value;
      success.Details.push({
        Label: successLabels.details[0].detailLabel,
        Value: `${selectedPaymethod.PaymentAccountType}`,
      });
    } else {
      success.Details.push({
        Label: successLabels.details[0].detailLabel,
        Value: this.payment.getPaymethodDescription(
          payRequest.PaymentAccountType as PaymentAccountType,
          payRequest.LastFour,
          payRequest.Nickname,
        ),
      });
    }
    success.Details.push({
      Label: successLabels.details[2].detailLabel,
      Value: format(payRequest.Date!, 'MM/dd/yyyy'),
    });
    success.Details.push({ Label: successLabels.details[1].detailLabel, Value: `${confirmationNumber}` });

    // Only display AutoPay sign up link if account is Not on AutoPay
    if (!this.accountDetail.IsAutoPay) {
      success.LinkList.push({
        Label: successLabels.linkList[0].linkLabel,
        Link: successLabels.linkList[0].linkUrl,
        AriaLabel: successLabels.linkList[0].linkAltText,
      });
    }

    success.CTAList.push({
      Label: successLabels.ctaList[0].ctaLabel,
      Link: successLabels.ctaList[0].ctaUrl,
      AriaLabel: successLabels.ctaList[0].ctaAriaLabel,
    });
    success.DetailPostMessage = successLabels.DetailPostMessage;
    this.storage.setSession(StorageEnum.SuccessData, success);
  }

  setSuccessDataWithError(payRequest: BankPayment, errorCode: string): void {
    const successLabels = this.pageLabels.paymentSuccessLabelsList.find((labels: any) => {
      return labels.name === 'PaymentSuccess';
    }).data;
    const success = new SuccessData();
    const newPaymentError = this.paymentErrors.find((error) => {
      return error.paymentError?.errorCode === errorCode;
    });

    success.Header = newPaymentError.paymentError?.errorHeader; // errorDetail.Header;
    success.Subheader = newPaymentError.paymentError?.displayMessage;
    success.PaymentAmount.Label = successLabels.paymentAmountLabel;
    success.PaymentAmount.Value = payRequest.Amount!;
    if (this.selectedPaymethodType === 'DIGITAL') {
      const selectedPaymethod = this.paymentForm.get('paymethod')?.value;
      success.Details.push({
        Label: successLabels.details[0].detailLabel,
        Value: `${selectedPaymethod.PaymentAccountType}`,
      });
    } else {
      success.Details.push({
        Label: successLabels.details[0].detailLabel,
        Value: this.payment.getPaymethodDescription(
          payRequest.PaymentAccountType as PaymentAccountType,
          payRequest.LastFour,
          payRequest.Nickname,
        ),
      });
    }
    success.Details.push({
      Label: successLabels.details[4].detailLabel,
      Value: `${this.creditP.transform(this.currencyP.transform(payRequest.CurrentBalance))}`,
    });

    // Only display AutoPay sign up link if account is Not on AutoPay
    if (!this.accountDetail.IsAutoPay) {
      success.LinkList.push({
        Label: successLabels.linkList[0].linkLabel,
        Link: successLabels.linkList[0].linkUrl,
        AriaLabel: successLabels.linkList[0].linkAltText,
      });
    }

    success.CTAList.push({
      Label: successLabels.ctaList[0].ctaLabel,
      Link: successLabels.ctaList[0].ctaUrl,
      AriaLabel: successLabels.ctaList[0].ctaAriaLabel,
    });
    this.storage.setSession(StorageEnum.SuccessData, success);
  }

  makeBankPayment(): void {
    const payRequest = this.buildBankRequest();
    this.payment.makeBankPayment(payRequest).subscribe({
      error: (e) => {
        if (e.message === PaymentErrorCode.PaymentNotPostedtoCCS) {
          this.setSuccessDataWithError(payRequest, e.message);
          void this.router.navigateByUrl(Nav.PaymentSuccess);
        } else {
          this.setErrorData(e.message, payRequest);
          void this.router.navigateByUrl(Nav.ErrorPage);
        }
      },
      next: (data: PaymentResponse) => {
        this.refreshPaymentData(data);
        this.setSuccessData(payRequest, data);
        void this.router.navigateByUrl(Nav.PaymentSuccess);
      },
    });
  }

  makeCardPayment(): void {
    const payRequest = this.buildCardRequest();
    this.payment.makeCreditCardPayment(payRequest).subscribe({
      error: (e) => {
        if (e.message === PaymentErrorCode.PaymentNotPostedtoCCS) {
          this.setSuccessDataWithError(payRequest, e.message);
          void this.router.navigateByUrl(Nav.PaymentSuccess);
        } else {
          this.setErrorData(e.message, payRequest);
          void this.router.navigateByUrl(Nav.ErrorPage);
        }
      },
      next: (data: PaymentResponse) => {
        this.refreshPaymentData(data);
        this.setSuccessData(payRequest, data);
        void this.router.navigateByUrl(Nav.PaymentSuccess);
      },
    });
  }

  makeFuturePayment(): void {
    const selectedPaymethod = this.paymentForm.get('paymethod')?.value;
    let futurePaymentRequest = new FuturePaymentRequest();
    futurePaymentRequest = this.buildPaymentRequest();
    futurePaymentRequest.ActionCode = 'A';
    futurePaymentRequest.BankAccountType = selectedPaymethod.BankAccountType;
    this.payment.postFuturePayment(futurePaymentRequest).subscribe({
      error: (e) => {
        this.setErrorData(e.message);
        void this.router.navigateByUrl(Nav.ErrorPage);
      },
      next: (data: FuturePayment) => {
        this.accountDetail.FuturePayment = data;
        this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
        this.setFutureDatedPaymentSuccessData(futurePaymentRequest, data);
        this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
        void this.router.navigateByUrl(Nav.PaymentSuccess);
      },
    });
  }

  createToDo(): void {
    const createToDO = new CreateToDo();
    createToDO.AccountNumber = this.accountDetail.AccountNumber;
    createToDO.ToDoRole = 'CCWEBORD';
    createToDO.ToDoType = 'CM-RECON';
    createToDO.Comments = '';
    this.customer.createToDo(createToDO).subscribe({
      error: () => {},
      next: () => {},
    });
  }

  createCustomerContact(): void {
    const today = new Date();
    const formattedDate = format(today, 'dd MMMM yyyy');
    const createCustContact = new CreateCustomerContact();
    createCustContact.AccountNumber = this.accountDetail.AccountNumber;
    createCustContact.ContactType = 'RECONT-REQ';
    createCustContact.Email = this.accountDetail.Email;
    const comments = this.pageLabels.createCustomerContactComments
      .replace('{0}', this.accountDetail.AccountNumber)
      .replace('{1}', this.accountDetail.FirstName)
      .replace('{2}', this.accountDetail.LastName)
      .replace('{3}', formattedDate);
    createCustContact.Comments = comments;
    this.customer.createCustomerContact(createCustContact).subscribe({
      error: () => {},
      next: () => {},
    });
  }

  setErrorData(errorCode: string, paymentRequest?: any): void {
    let payType = this.selectedPaymethodType;
    if (this.selectedPaymethodType === 'DIGITAL') {
      const selectedPaymethod = this.paymentForm.get('paymethod')?.value;
      payType = selectedPaymethod.PaymentAccountType;
    } else {
      payType = paymentRequest.Nickname ? paymentRequest.Nickname : paymentRequest.PaymentAccountType;
    }
    const newPaymentError = this.paymentErrors.find((error) => {
      return error.paymentError?.errorCode === errorCode;
    });
    const errorLabels = this.pageLabels.paymentErrorLabels.value.data.ctaList[0];
    const errorDetail = new ErrorData();
    errorDetail.ErrorCode = newPaymentError.paymentError?.errorCode;
    errorDetail.Header = newPaymentError.paymentError?.errorHeader;
    let errorMessage = newPaymentError.paymentError?.displayMessage;
    if (paymentRequest) {
      errorMessage = errorMessage.replace('{{$}}', '$' + paymentRequest.Amount);
      errorMessage = errorMessage.replace('{{PaymentType}}', payType);
      errorMessage = errorMessage.replace('{{LastFour}}', paymentRequest.LastFour);
    }
    errorDetail.Subheader = errorMessage;
    errorDetail.CtaButton.Label = errorLabels.ctaLabel;
    errorDetail.CtaButton.Link = errorLabels.ctaUrl;
    errorDetail.CtaButton.AriaLabel = errorLabels.ctaAriaLabel;
    this.storage.setSession(StorageEnum.ErrorData, errorDetail);
  }

  refreshPaymentData(res: PaymentResponse): void {
    // merge new values back to account detail
    this.accountDetail.CurrentBalance = res.CurrentBalance;
    this.accountDetail.PastDueBalance = res.PastDueBalance;
    this.accountDetail.MinimumPayment = res.MinimumPayment;

    // put updated data into storage
    this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
    this.getPaymentOptions();
  }

  buildBankRequest(): BankPayment {
    const selectedPaymethod = this.paymentForm.get('paymethod')?.value;
    let bankPayment = new BankPayment();
    bankPayment = this.buildPaymentRequest();
    bankPayment.BankAccountNumber = selectedPaymethod.BankAccountNumber;
    bankPayment.BankRoutingNumber = selectedPaymethod.BankRoutingNumber;
    bankPayment.BankAccountType = selectedPaymethod.BankAccountType;
    return bankPayment;
  }

  buildCardRequest(): CardPayment {
    const selectedPaymethod = this.paymentForm.get('paymethod')?.value;
    let cardPayment = new CardPayment();
    cardPayment = this.buildPaymentRequest();
    cardPayment.ExpirationDate = selectedPaymethod.ExpDate;
    cardPayment.Fee = '0';
    cardPayment.PostalCode = cardPayment.Person?.BillingAddress?.PostalCode;
    cardPayment.Cvv = 0;
    return cardPayment;
  }

  buildPaymentRequest(): Payment {
    const selectedPaymethod = this.paymentForm.get('paymethod')?.value;

    const payment = new Payment();
    payment.Person = this.accountDetail.Person;
    payment.CustomerClass = this.accountDetail.CustomerClass;
    if (this.paymentForm.get('payamount')?.value === 'other') {
      payment.Amount = this.paymentForm.get('otheramount')?.value;
    } else {
      // update payment amount to include trailing zeros and 2 decimal places.
      let payAmountformatted = this.paymentForm.get('payamount')?.value;
      payAmountformatted = this.decimalPipe.transform(payAmountformatted, '1.2-2');
      payment.Amount = payAmountformatted;
    }
    payment.Date = this.paymentForm.get('paydate')?.value;
    payment.AccountNumber = this.accountDetail.AccountNumber;
    payment.IsInSeverance = this.accountDetail.IsSevered;
    payment.Token = selectedPaymethod.ReferenceId;
    payment.LastFour = selectedPaymethod.LastFour;
    payment.PaymentAccountType = selectedPaymethod.PaymentAccountType?.replaceAll(' ', '');
    if (selectedPaymethod.Nickname) {
      payment.Nickname = selectedPaymethod.Nickname;
    }
    if (selectedPaymethod.SaveToAccount) {
      payment.SaveToAccount = selectedPaymethod.SaveToAccount;
    } else {
      payment.SaveToAccount = false;
    }
    payment.SaveAsDefault = selectedPaymethod.IsDefault;
    payment.UserName = this.userProfile?.UserName;
    payment.CurrentBalance = this.accountDetail.CurrentBalance;
    payment.PastDueBalance = this.accountDetail.PastDueBalance;
    payment.MinimumPayment = this.accountDetail.MinimumPayment;
    return payment;
  }

  findLocations(): void {
    window.open('https://www.gas-south.com/paymentlocations.aspx', '_blank');
  }

  accountHasBalance(): boolean {
    const totalBalance = this.accountDetail?.CurrentBalance ?? 0;
    return totalBalance > 0;
  }

  setupEmailData(): void {
    this.emailFormData.showConfirmEmail = true;
    this.emailFormData.formGroup = this.fb.group({
      email: ['', [Validators.required, emailValidator()]],
      emailConfirm: ['', [Validators.required, emailValidator()]],
    });
  }
}
